import { attributes_map } from './AttributesMap';
import { convertStyle } from './HTMLStyle';
const VOID_TAG = [
    'area', 'base',
    'br', 'col', 'embed', 'hr', 'img',
    'input', 'link', 'meta', 'param',
    'source', 'track', 'wbr'
];
var NODE_TYPE;
(function (NODE_TYPE) {
    NODE_TYPE[NODE_TYPE["text"] = 0] = "text";
    NODE_TYPE[NODE_TYPE["self"] = 1] = "self";
    NODE_TYPE[NODE_TYPE["close"] = 2] = "close";
    NODE_TYPE[NODE_TYPE["start"] = 3] = "start";
})(NODE_TYPE || (NODE_TYPE = {}));
const specialChars = [['&nbsp;', ' '], ['&rsquo;', '\''], ['&rdquo;', '"'], ['&ldquo;', '"'], ['&ndash;', '-'], ['&amp;', '&']];
const removeScript = (str) => str.replace(/<script[^>]*>([^]*?)<\/script>/g, '');
const correctBracket = (str) => str.replace(/("[^<>\/"]*)<([^<>\/"]+)>([^<>\/"]*")/g, '"$1|$2|$3"');
const removeComment = (str) => str.replace(/<!--[^>]*-->/g, '');
const removeBreakLine = (str) => str.replace(/[\r\n\t]/g, '');
const replaceSpecialChars = (str) => {
    return specialChars.reduce((acc, [char, value]) => acc.replaceAll(char, value), str);
};
function convertAttributes(str) {
    if (!str) {
        return {};
    }
    const result = {};
    const arr = str.replace(/[\s]+/g, ' ').trim().match(/([\S]+="[^"]*")|([^\s"]+)/g) || [];
    arr.forEach((item) => {
        if (item.indexOf('=') === -1) {
            result[item] = true;
        }
        else {
            const match = item.match(/([^=]+)=([^]*)/) || [];
            const key = attributes_map[match[1]]
                ? attributes_map[match[1]]
                : match[1];
            result[key] = (match[2] && match[2].replace(/^"([^]*)"$/, '$1'));
        }
    });
    if (result.style) {
        result.style = convertStyle(result.style);
    }
    if (result.class) {
        result.className = convertClass(result.class);
        result.class = undefined;
    }
    return result;
}
function convertClass(str) {
    if (!str || typeof str !== 'string') {
        return [];
    }
    return str
        .trim()
        .replace(/['"]/g, '')
        .replace(/[\s]+/g, ' ')
        .split(' ');
}
function getBodyIfHave(str) {
    const match = str.match(/<body[^>]*>([^]*)<\/body>/);
    if (!match) {
        return str;
    }
    return match[1];
}
function getStackOfElements(str) {
    const pattern = /(<[^<>]+>)/g;
    let pointer = 0;
    let match;
    let stack = [];
    while (match = pattern.exec(str)) {
        const text = str.slice(pointer, match.index);
        if (text.trim()) {
            stack.push({
                type: NODE_TYPE.text,
                text
            });
        }
        const line = match[1].trim();
        if (line) {
            const image_match = line.match(/<([^\s<>]+) ?([^<>]*)\/>/);
            const div_close_match = line.match(/<\/([^\s<>]+)>/);
            const div_open_match = line.match(/<([^\s<>]+) ?([^<>]*)>/);
            if (image_match) {
                stack.push({
                    type: VOID_TAG.includes(image_match[1])
                        ? NODE_TYPE.self
                        : NODE_TYPE.close,
                    name: image_match[1],
                    props: convertAttributes(image_match[2]),
                    text: line
                });
            }
            else if (div_close_match) {
                if (!VOID_TAG.includes(div_close_match[1])) {
                    stack.push({
                        type: NODE_TYPE.close,
                        name: div_close_match[1],
                        text: line
                    });
                }
            }
            else if (div_open_match) {
                stack.push({
                    type: NODE_TYPE.start,
                    name: div_open_match[1],
                    props: convertAttributes(div_open_match[2]),
                    text: line
                });
            }
        }
        pointer = match.index + match[0].length;
    }
    return stack;
}
function createTextNode(text, parent) {
    return {
        type: 'text',
        name: 'text',
        props: {},
        children: [],
        data: text,
        parent
    };
}
function createTagNode(node, parent) {
    return {
        type: 'tag',
        name: node.name || 'text',
        props: node.props || {},
        children: [],
        parent
    };
}
function parseChildren(str) {
    if (!str) {
        return [];
    }
    const stack = getStackOfElements(str);
    let children = [];
    let currentNode = undefined;
    if (stack.length > 0) {
        stack.forEach((node) => {
            if (node.type === NODE_TYPE.text) {
                if (currentNode) {
                    currentNode.children.push(createTextNode(node.text, currentNode));
                }
                else {
                    children.push(createTextNode(node.text));
                }
            }
            else if (node.type === NODE_TYPE.close) {
                if (!currentNode) {
                    console.error('parse error');
                }
                else {
                    if (node.name === currentNode.name) {
                        currentNode = currentNode.parent;
                    }
                    else {
                        currentNode = currentNode.parent;
                        console.error('Closing tag is missing!');
                    }
                }
            }
            else if (node.type === NODE_TYPE.start && VOID_TAG.indexOf(node.name || '') === -1) {
                const newNode = createTagNode(node, currentNode);
                if (!currentNode) {
                    children.push(newNode);
                }
                else {
                    currentNode.children.push(newNode);
                }
                currentNode = newNode;
            }
            else if (node.type === NODE_TYPE.self || VOID_TAG.indexOf(node.name || '') !== -1) {
                if (currentNode) {
                    currentNode.children.push(createTagNode(node, currentNode));
                }
                else {
                    children.push(createTagNode(node));
                }
            }
        });
    }
    return children;
}
export const DOMParser = (html) => parseChildren(replaceSpecialChars(correctBracket(getBodyIfHave(removeBreakLine(removeComment(removeScript(html)))))));
